<template>
    <div>
        <AlertBox id="cart-alert-box" ref="alertBox"></AlertBox>
        <div
            class="payment-layout"
            :class="'cart-' + (cart.places.length ? 'filled' : 'empty')"
        >
            <div class="blocks-list">
                <div
                    class="message-empty"
                    v-show="!cart.places.length"
                    v-html="trans('user.cart.is_empty')"
                ></div>

                <template v-if="cart.places.length">
                    <div
                        class="course-place"
                        v-for="place in cart.places"
                        :key="place.name"
                    >
                        <template v-for="course in place.courses">
                            <template v-for="date in course.dates">
                                <template v-for="ticket in date.items">
                                    <CourseOrder
                                        v-bind:key="course.id + '-' + ticket.id"
                                        v-bind:order="
                                            courseToOrder(
                                                course,
                                                place.city,
                                                ticket.quantity,
                                                ticket.price,
                                                ticket.currency,
                                                null,
                                                ticket,
                                                date.event
                                            )
                                        "
                                        :editable="true"
                                    ></CourseOrder>
                                </template>
                            </template>
                        </template>
                        <template v-for="pack in place.packs">
                            <CourseOrder
                                v-bind:key="pack.cartItemId"
                                v-bind:order="
                                    packToOrder(
                                        pack,
                                        place.city,
                                        pack.quantity,
                                        pack.price,
                                        pack.currency,
                                        null
                                    )
                                "
                                :editable="true"
                            ></CourseOrder>
                            <!--                  v-bind:location="place.name"-->
                        </template>
                    </div>
                </template>

                <div class="book-more">
                    <span
                        v-html="
                            trans(
                                'user.cart.resume_shopping.suggestion_message'
                            )
                        "
                    ></span>

                    <span>
                        <a
                            data-toggle="modal"
                            data-target="#modal-cities-city-home"
                            href="#"
                            v-html="
                                trans(
                                    'user.cart.resume_shopping.face_to_face_course'
                                )
                            "
                        >
                        </a>
                    </span>

                    <span v-html="trans('common.or')"></span>

                    <span>
                        <a
                            :href="onlineShopUrl"
                            v-html="
                                trans('user.cart.resume_shopping.online_course')
                            "
                        >
                        </a>
                    </span>
                </div>
            </div>
            <div class="checkout-summary">
                <CheckoutSummary
                    ref="summary"
                    :cart="cart"
                    :coupons="couponList"
                    :editable="true"
                ></CheckoutSummary>
                <a
                    class="button-checkout"
                    v-if="cart.places.length"
                    v-bind:href="userCheckoutPath"
                    v-html="trans('user.cart.checkout')"
                    v-on:click="onClickCheckout"
                >
                </a>
            </div>
            <CartGiftCardModal id="gift-card-modal"></CartGiftCardModal>
        </div>
    </div>
</template>

<script>
import AlertBox from './../../../vue/AlertBox.vue';
import CourseOrder from './profile/partial/CourseOrder.vue';
import CartManager from './CartManager.vue';
import CheckoutSummary from './CheckoutSummary.vue';
import CartGiftCardModal from './CartGiftCardModal.vue';
import LoadingOverlay from './../../../vue/LoadingOverlay.vue';
import { courseToOrder, packToOrder } from './../../../helper/polyfill';

export default {
    extends: CartManager,

    props: {
        onlineShopUrl: String,
        faceToFaceShopUrl: String,
    },

    data() {
        return {
            token: document.querySelector('meta[name="csrf-token"]').content,
            userCheckoutPath: appData.page.vars.userCheckoutPath,
            errors: {},
            faceToFaceShopUrlSanitized: this.faceToFaceShopUrl || '#',
        };
    },

    components: {
        AlertBox,
        CourseOrder,
        CartGiftCardModal,
        CheckoutSummary,
        LoadingOverlay,
    },

    methods: {
        courseToOrder,
        packToOrder,
        onClickCheckout() {
            // Trigger GTM event.
            this.app.gtm.trigger('begin_checkout', appData.page.vars.gtmData);
        },
    },
};
</script>
